import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './ImageCreationChoice.css'; // Asegúrate de crear este archivo de estilos
import Carrusel from './Imagenes/carrusel.png';
import Imagen from './Imagenes/imagen.png'
import { Helmet } from 'react-helmet';

const ImageCreationChoice: React.FC = () => {
  const history = useHistory();

  const handleSingleImageClick = () => {
    history.push('/Social-Networking');
  };

  const handleCarouselClick = () => {
    history.push('/Social-Networking-Carousel');
  };
  const handleReelClick = () => {
    history.push('/Social-Networking-Reel');
  };
  useEffect(() => {
    // Verificar si el usuario está autenticado
    const userId = localStorage.getItem('userId');
    if (!userId) {
      // Redirigir a la página de inicio de sesión si no está autenticado
      history.push('/PantallaInicial');
    }
  }, [history]);

  return (
    <div className="choice-container">
      <Helmet>
        <title>Redes Sociales - Taapt</title>
      </Helmet>
      <h2>¿Qué deseas <span>crear</span>?</h2>
      <div className="choice-cards">
        <div>
          <div className="choice-card" >
            <div className="icon"><img src={Imagen} alt="" /></div>
            <h3>IMAGEN</h3>
            <p>Crea una imagen única para tus redes sociales.</p>
          </div>
          <button className='Choice-button' onClick={handleSingleImageClick}>✔ Seleccionar</button>
        </div>
        <div>
          <div className="choice-card" >
            <div className="icon"><img src={Carrusel} alt="carrusel"  /></div>
            <h3>CARROUSEL</h3>
            <p>Crea un conjunto de imágenes para tus redes sociales.</p>
          </div>
          <button className='Choice-button' onClick={handleCarouselClick}>✔ Seleccionar</button>
        </div>
        <div>
          <div className="choice-card" >
            <div className="icon"><img src={Carrusel} alt="carrusel"  /></div>
            <h3>REEL</h3>
            <p>Sube un video en formato reel para tus redes sociales.</p>
          </div>
          <button className='Choice-button' onClick={handleReelClick}>✔ Seleccionar</button>
        </div>
      </div>
    </div>
  );
};

export default ImageCreationChoice;
